import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import get from 'lodash.get';
import { Money2 } from '~/modules/common/components';

const useStyles = makeStyles(theme => ({
  currencyRoot: {
    fontSize: theme.typography.body2.fontSize,
    marginTop: theme.spacing(1),
    textAlign: 'left'
  },
  adornmentRoot: {
    marginTop: '0px'
  },
  amountField: {
    fontSize: theme.typography.body2.fontSize,
    height: 'auto'
  }
}));

export const MoneyEditor = ({
  field,
  column: {
    id: columnId,
    setFieldValue,
    errors,
    isMobile,
    label,
    onShowWarning,
    currencyEditable,
    currencyLabel
  },
  record,
  index,
  classes: classesOverride
}) => {
  const { formatMessage } = useIntl();
  const classes = useStyles({ classes: classesOverride });

  const amountStyles = useMemo(
    () => ({
      adornmentRoot: classes.adornmentRoot,
      currencyRoot: classes.currencyRoot
    }),
    [classes.adornmentRoot, classes.currencyRoot]
  );
  const { amount, currency } = record[field] || {};

  const amountChangeHandler = useCallback(
    e => {
      setFieldValue(
        `scripts[${index}].${columnId}.amount`,
        e.target.value || 0
      );
      if (onShowWarning) onShowWarning(true);
    },
    [columnId, index, onShowWarning, setFieldValue]
  );

  const currencyChangeHandler = useCallback(
    newCurrency => {
      setFieldValue(`scripts[${index}].${columnId}.currency`, newCurrency);
      if (onShowWarning) onShowWarning(true);
    },
    [columnId, index, onShowWarning, setFieldValue]
  );

  const requiredError = useMemo(
    () => get(errors, `parameters['${columnId}'][${index}]`),
    [columnId, errors, index]
  );

  return (
    <Money2
      classes={amountStyles}
      className={classes.amountField}
      amount={amount}
      currency={currency}
      currencyEditable={currencyEditable}
      onAmountChange={amountChangeHandler}
      onCurrencyChange={currencyChangeHandler}
      error={Boolean(requiredError)}
      helperText={requiredError}
      hiddenLabel={!isMobile}
      currencyLabel={isMobile ? null : currencyLabel}
      label={label}
      ariaLabel={formatMessage({
        id: 'projectRevenueRecognitionCard.baseContractValue'
      })}
    />
  );
};

MoneyEditor.propTypes = {
  column: PropTypes.object.isRequired,
  classes: PropTypes.object,
  record: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired
};

export default MoneyEditor;
